import angular from 'angular'
import { statisticsInvState } from 'redevConfig'
const list = (statisticsInvState && statisticsInvState.list) || ''
const detail = (statisticsInvState && statisticsInvState.detail) || ''

const statisticsInvStateList = list ? require(`redevelopment/statistics/statisticsInvState/${list.templateName}`) : require('./view/statisticsInvStateList.html')
const statisticsInvStateListCtrl = list ? require(`redevelopment/statistics/statisticsInvState/${list.controllerName}`) : require('./statisticsInvStateListCtrl')

const statisticsInvStateDetail = detail ? require(`redevelopment/statistics/statisticsInvState/${detail.templateName}`) : require('./view/relatedBill_invoice.html')
const statisticsInvStateDetailCtrl = detail ? require(`redevelopment/statistics/statisticsInvState/${detail.controllerName}`) : require('./statisticsInvStateDetailCtrl')

export default angular
    .module('app.statisticsInvState', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state('statistics.outputStatistics.statisticsInvState', {
                abstract: true,
                url: '/statisticsInvState',
                template: '<div ui-view></div>',
                title: '状态统计',
                default: 'statistics.outputStatistics.statisticsInvState.list',
            })
            .state('statistics.outputStatistics.statisticsInvState.list', {
                url: '/list',
                template: statisticsInvStateList,
                controller: 'statisticsInvStateListCtrl',
            })
            .state('statistics.outputStatistics.statisticsInvState.detail', {
                url: '/detail/:param',
                template: statisticsInvStateDetail,
                controller: 'statisticsInvStateDetailCtrl',
                title: '统计详情',
            })
    }])
    .controller('statisticsInvStateListCtrl', statisticsInvStateListCtrl.default)
    .controller('statisticsInvStateDetailCtrl', statisticsInvStateDetailCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/statistics/outputStatistics/statisticsInvState/index.js